var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 8,
    viewBox: "0 0 32 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.72265 5.58397C0.492886 5.73715 0.430799 6.04759 0.583975 6.27735C0.737151 6.50711 1.04759 6.5692 1.27735 6.41603L0.72265 5.58397ZM31.0981 6.49029C31.3688 6.43613 31.5444 6.17272 31.4903 5.90194L30.6078 1.48933C30.5536 1.21855 30.2902 1.04294 30.0194 1.0971C29.7486 1.15125 29.573 1.41467 29.6272 1.68544L30.4117 5.60777L26.4893 6.39223C26.2185 6.44639 26.0429 6.7098 26.0971 6.98058C26.1513 7.25136 26.4147 7.42697 26.6854 7.37281L31.0981 6.49029ZM1.27735 6.41603L2.96455 5.29122L2.40985 4.45917L0.72265 5.58397L1.27735 6.41603ZM29.0354 5.29122L30.7227 6.41603L31.2773 5.58397L29.5901 4.45917L29.0354 5.29122ZM2.96455 5.29122C10.8582 0.0288005 21.1418 0.028801 29.0354 5.29122L29.5901 4.45917C21.3606 -1.02718 10.6394 -1.02718 2.40985 4.45917L2.96455 5.29122Z",
    fill: "#8B997F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow-1.86cd9bf2f51f734162d7327d0c65746c.svg";
export { ForwardRef as ReactComponent };